'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spinnerColor = _scales2.default.neutral.N6A;

exports.default = spinnerColor;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvc3Bpbm5lckNvbG9yLmpzIl0sIm5hbWVzIjpbInNwaW5uZXJDb2xvciIsInNjYWxlcyIsIm5ldXRyYWwiLCJONkEiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7Ozs7QUFFQSxJQUFNQSxlQUFlQyxpQkFBT0MsT0FBUCxDQUFlQyxHQUFwQzs7a0JBRWVILFkiLCJmaWxlIjoic3Bpbm5lckNvbG9yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHNjYWxlcyBmcm9tICcuLi9mb3VuZGF0aW9uYWwtc3R5bGVzL3NjYWxlcydcblxuY29uc3Qgc3Bpbm5lckNvbG9yID0gc2NhbGVzLm5ldXRyYWwuTjZBXG5cbmV4cG9ydCBkZWZhdWx0IHNwaW5uZXJDb2xvclxuIl19